export const isResumableCheckoutUrl = (
  url: string | null | undefined,
): url is string => Boolean(url) && /^https?:\/\//.test(String(url))
